module.exports = __webpack_public_path__ + "img/back3.70e1e2e2.png";